const pagesSupplierLedgerEn = {
  detailBodyAvlEntryAddEntry: 'Add AVL Entry',
  detailBodyAvlEntryEntryLabel: 'AVL Entry',
  detailBodyAvlEntryFieldsAvlApprovalDate: 'AVL Approval Date',
  detailBodyAvlEntryFieldsAvlApprovalNotes: 'Notes',
  detailBodyAvlEntryFieldsAvlApprovedBy: 'Approved By',
  detailBodyAvlEntryFieldsAvlEntryStatus: 'AVL Status',
  detailBodyAvlEntryFieldsAvlReviewDate: 'AVL Review Date',
  detailBodyAvlEntryFieldsNewVendorApprovalRequired:
    'New Vendor Approval Required',
  detailBodyAvlEntryFieldsScopeType: 'Scope Type',
  detailBodyAvlEntryFieldsScopeValue: 'Scope Value',
  detailBodyAvlEntryFieldsSoleSourceApprovedFlag: 'Sole Source Approved',
  detailBodyAvlEntryFieldsSoleSourceJustification: 'Sole Source Justification',
  detailBodyAvlEntryNoEntries: 'No AVL entries found.',
  detailBodyBusinessPartnerLink: 'Business Partner',
  detailBodyGroupsBankAccounts: 'Bank Accounts & Remit-To Details',
  detailBodyGroupsContractsAndDocument: 'Contracts & Document',
  detailBodyGroupsCorporateInformation: 'Supplier Information',
  detailBodyGroupsProcurementCommercialTerms: 'Procurement & Commercial Terms',
  detailBodyGroupsVendorSupplierCodeInformation: 'Vendor/Supplier Information',
  detailBodyNoDataMessage: 'No data available in this section.',
  detailBodyTerminateConfirmDescription:
    'Set the status to Terminated? This supplier will no longer be editable after the change.',
  detailBodyTerminateConfirmTitle: 'Set status to Terminated?',
  detailHeaderAssignedBuyer: 'Assigned Buyer',
  detailTabsDetail: 'Detail',
  detailTabsFiles: 'Files',
  detailTabsRulesAndPolicy: 'Rules & Policy',
  detailTabsSettings: 'Settings',
  listFilterPlaceholder: 'Search by supplier name or code...',
  listPageTitle: 'Suppliers',
  listTabsAll: 'All',
  listTabsOnHold: 'On Hold',
  listTabsOperating: 'Operating',
  listTabsSuspended: 'Suspended',
  listTabsTerminated: 'Terminated',
  settingsPageTitle: 'Supplier Settings',
  settingsProcurementCategoriesAddProcurementCategory:
    'Add Procurement Category',
  settingsProcurementCategoriesDescription:
    'Manage procurement categories used to classify purchases.',
  settingsProcurementCategoriesDisableDialogCancel: 'Cancel',
  settingsProcurementCategoriesDisableDialogConfirm: 'Deactivate',
  settingsProcurementCategoriesDisableDialogDescription:
    'Are you sure you want to deactivate {{name}}? It will no longer be available for selection.',
  settingsProcurementCategoriesDisableDialogErrorTitle: 'Failed to deactivate',
  settingsProcurementCategoriesDisableDialogSuccessDescription:
    '{{name}} has been deactivated.',
  settingsProcurementCategoriesDisableDialogSuccessTitle: 'Deactivated',
  settingsProcurementCategoriesDisableDialogTitle:
    'Deactivate Procurement Category',
  settingsProcurementCategoriesEditProcurementCategory: 'Edit {{name}}',
  settingsProcurementCategoriesEnableDialogCancel: 'Cancel',
  settingsProcurementCategoriesEnableDialogConfirm: 'Activate',
  settingsProcurementCategoriesEnableDialogDescription:
    'Are you sure you want to activate {{name}}?',
  settingsProcurementCategoriesEnableDialogErrorTitle: 'Failed to activate',
  settingsProcurementCategoriesEnableDialogSuccessDescription:
    '{{name}} has been activated.',
  settingsProcurementCategoriesEnableDialogSuccessTitle: 'Activated',
  settingsProcurementCategoriesEnableDialogTitle:
    'Activate Procurement Category',
  settingsProcurementCategoriesFormDescriptionLabel: 'Description',
  settingsProcurementCategoriesFormDescriptionPlaceholder:
    'Enter a description',
  settingsProcurementCategoriesFormDisplayOrderDescription:
    'Leave blank to append at the end.',
  settingsProcurementCategoriesFormDisplayOrderLabel: 'Display Order',
  settingsProcurementCategoriesFormDisplayOrderPlaceholder: 'e.g. 10',
  settingsProcurementCategoriesFormErrorSaveFailed:
    'Failed to save. Please try again.',
  settingsProcurementCategoriesFormNameLabel: 'Name',
  settingsProcurementCategoriesFormNamePlaceholder: 'Enter a name',
  settingsProcurementCategoriesSearchPlaceholder: 'Search by name...',
  settingsProcurementCategoriesShowDeactivated: 'Show deactivated',
  settingsProcurementCategoriesTableDescription: 'Description',
  settingsProcurementCategoriesTableDisplayOrder: 'Display Order',
  settingsProcurementCategoriesTableName: 'Name',
  settingsProcurementCategoriesTitle: 'Procurement Categories',
  settingsSharedActionsColumnDisableButton: 'Deactivate',
  settingsSharedActionsColumnEnableButton: 'Activate',
  settingsSupplierCategoriesAddSupplierCategory: 'Add Supplier Category',
  settingsSupplierCategoriesDescription:
    'Manage supplier categories used to classify suppliers.',
  settingsSupplierCategoriesDisableDialogCancel: 'Cancel',
  settingsSupplierCategoriesDisableDialogConfirm: 'Deactivate',
  settingsSupplierCategoriesDisableDialogDescription:
    'Are you sure you want to deactivate {{name}}? It will no longer be available for selection.',
  settingsSupplierCategoriesDisableDialogErrorTitle: 'Failed to deactivate',
  settingsSupplierCategoriesDisableDialogSuccessDescription:
    '{{name}} has been deactivated.',
  settingsSupplierCategoriesDisableDialogSuccessTitle: 'Deactivated',
  settingsSupplierCategoriesDisableDialogTitle: 'Deactivate Supplier Category',
  settingsSupplierCategoriesEditSupplierCategory: 'Edit {{name}}',
  settingsSupplierCategoriesEnableDialogCancel: 'Cancel',
  settingsSupplierCategoriesEnableDialogConfirm: 'Activate',
  settingsSupplierCategoriesEnableDialogDescription:
    'Are you sure you want to activate {{name}}?',
  settingsSupplierCategoriesEnableDialogErrorTitle: 'Failed to activate',
  settingsSupplierCategoriesEnableDialogSuccessDescription:
    '{{name}} has been activated.',
  settingsSupplierCategoriesEnableDialogSuccessTitle: 'Activated',
  settingsSupplierCategoriesEnableDialogTitle: 'Activate Supplier Category',
  settingsSupplierCategoriesFormDescriptionLabel: 'Description',
  settingsSupplierCategoriesFormDescriptionPlaceholder: 'Enter a description',
  settingsSupplierCategoriesFormDisplayOrderDescription:
    'Leave blank to append at the end.',
  settingsSupplierCategoriesFormDisplayOrderLabel: 'Display Order',
  settingsSupplierCategoriesFormDisplayOrderPlaceholder: 'e.g. 10',
  settingsSupplierCategoriesFormErrorSaveFailed:
    'Failed to save. Please try again.',
  settingsSupplierCategoriesFormNameLabel: 'Name',
  settingsSupplierCategoriesFormNamePlaceholder: 'Enter a name',
  settingsSupplierCategoriesSearchPlaceholder: 'Search by name...',
  settingsSupplierCategoriesShowDeactivated: 'Show deactivated',
  settingsSupplierCategoriesTableDescription: 'Description',
  settingsSupplierCategoriesTableDisplayOrder: 'Display Order',
  settingsSupplierCategoriesTableName: 'Name',
  settingsSupplierCategoriesTitle: 'Supplier Categories',
  settingsSupplierSubcategoriesAddSupplierSubcategory:
    'Add Supplier Subcategory',
  settingsSupplierSubcategoriesDescription:
    'Manage supplier subcategories linked to a parent category.',
  settingsSupplierSubcategoriesDisableDialogCancel: 'Cancel',
  settingsSupplierSubcategoriesDisableDialogConfirm: 'Deactivate',
  settingsSupplierSubcategoriesDisableDialogDescription:
    'Are you sure you want to deactivate {{name}}? It will no longer be available for selection.',
  settingsSupplierSubcategoriesDisableDialogErrorTitle: 'Failed to deactivate',
  settingsSupplierSubcategoriesDisableDialogSuccessDescription:
    '{{name}} has been deactivated.',
  settingsSupplierSubcategoriesDisableDialogSuccessTitle: 'Deactivated',
  settingsSupplierSubcategoriesDisableDialogTitle:
    'Deactivate Supplier Subcategory',
  settingsSupplierSubcategoriesEditSupplierSubcategory: 'Edit {{name}}',
  settingsSupplierSubcategoriesEnableDialogCancel: 'Cancel',
  settingsSupplierSubcategoriesEnableDialogConfirm: 'Activate',
  settingsSupplierSubcategoriesEnableDialogDescription:
    'Are you sure you want to activate {{name}}?',
  settingsSupplierSubcategoriesEnableDialogErrorTitle: 'Failed to activate',
  settingsSupplierSubcategoriesEnableDialogSuccessDescription:
    '{{name}} has been activated.',
  settingsSupplierSubcategoriesEnableDialogSuccessTitle: 'Activated',
  settingsSupplierSubcategoriesEnableDialogTitle:
    'Activate Supplier Subcategory',
  settingsSupplierSubcategoriesFilterChipLabel: 'Category',
  settingsSupplierSubcategoriesFormDescriptionLabel: 'Description',
  settingsSupplierSubcategoriesFormDescriptionPlaceholder:
    'Enter a description',
  settingsSupplierSubcategoriesFormDisplayOrderDescription:
    'Leave blank to append at the end.',
  settingsSupplierSubcategoriesFormDisplayOrderLabel: 'Display Order',
  settingsSupplierSubcategoriesFormDisplayOrderPlaceholder: 'e.g. 10',
  settingsSupplierSubcategoriesFormErrorSaveFailed:
    'Failed to save. Please try again.',
  settingsSupplierSubcategoriesFormNameLabel: 'Name',
  settingsSupplierSubcategoriesFormNamePlaceholder: 'Enter a name',
  settingsSupplierSubcategoriesFormSupplierCategoryMasterIdLabel:
    'Parent Category',
  settingsSupplierSubcategoriesFormSupplierCategoryMasterIdPlaceholder:
    'Select a category',
  settingsSupplierSubcategoriesSearchPlaceholder: 'Search by name...',
  settingsSupplierSubcategoriesShowDeactivated: 'Show deactivated',
  settingsSupplierSubcategoriesTableDescription: 'Description',
  settingsSupplierSubcategoriesTableDisplayOrder: 'Display Order',
  settingsSupplierSubcategoriesTableName: 'Name',
  settingsSupplierSubcategoriesTableParentCategory: 'Category',
  settingsSupplierSubcategoriesTitle: 'Supplier Subcategories',
};

export default pagesSupplierLedgerEn;
